module.exports = __webpack_public_path__ + "static/domain-whois_2-7316f5aeffab54dabfe61c06b048470c.jpg";